import React, {Component} from "react";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";

export class ConfirmDialog extends Component {
  constructor(props) {
    super(props);
    let isOpen = false;
    if (this.props.isOpen !== true || this.props.isOpen !== false) isOpen = this.props.isOpen;
    this.state = {
      isOpen: isOpen
    }
  }

  render() {
    let isOpen = this.state.isOpen;
    if (this.props.isOpen !== true || this.props.isOpen !== false) isOpen = this.props.isOpen;
    return (
      <Modal isOpen={isOpen}
             className={'modal-lg ' + this.props.className || ""}>
        <ModalHeader>{this.props.header || "Confirm"}</ModalHeader>
        <ModalBody>
          {this.props.children}
        </ModalBody>
        <ModalFooter>
          {this.props['onOk'] && (
            <Button color="primary"
                    onClick={() => this.setState({isOpen: false}, ()=>this.props['onOk']())}>Ok</Button>
          )}
          {this.props['onYes'] && (
            <Button color="secondary"
                    onClick={() => this.setState({isOpen: false}, ()=>this.props['onYes']())}>Yes</Button>
          )}
          {this.props['onNo'] && (
            <Button color="secondary"
                    onClick={() => this.setState({isOpen: false}, ()=>this.props['onNo']())}>No</Button>
          )}
          {this.props['onClose'] && (
            <Button color="secondary"
                    onClick={() => this.setState({isOpen: false}, ()=>this.props['onClose']())}>Close</Button>
          )}
          {this.props['onCancel'] && (
            <Button color="secondary"
                    onClick={() => this.setState({isOpen: false}, ()=>this.props['onCancel']())}>Cancel</Button>
          )}
        </ModalFooter>
      </Modal>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Shared/ConfirmDialog.js